import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>({
  wrapper: {
    width: 'calc(100% - 50px)',
    maxWidth: '1000px',
    height: '652px',
    boxShadow: '1px 3px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    padding: ' 0 0 48px',
    backgroundColor: 'white',
    left: '50%',
    top: '50%',
    position: 'relative',
    transform: 'translate(-50%, -50%)',
    ['@media (max-width:960px)']: {
      width: '100% !important',
      height: 'calc(100% - 48px)'
    },
    // ['@media (max-width:1010px)']: {
    //   overflow: 'hidden'
    // },
    [theme.breakpoints.down('sm')]:{
       width: '100%',
      height: 'calc(100% - 48px)'
    },
    [theme.breakpoints.down('xs')]:{
      width: '100%',
     height: 'calc(100% - 40px)'
   }
  },
  tabPanel: {
    height: '100%',
    
  },
  noItemMsg: {
    height: 'calc(100% - 80px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

export default useStyles;
